export function getCurrentYear(): number {
  return new Date().getFullYear();
}

export function getCurrentMonth(): number {
  return new Date().getMonth() + 1;
}

export function getCurrentYearMonth(): { year: number; month: number } {
  return {
    year: getCurrentYear(),
    month: getCurrentMonth(),
  };
}

export function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseYYYYMMDD(dateString: string): Date {
  return new Date(dateString);
}

export function formatAttendanceDate(date: string | Date): {
  dayName: string;
  dayNum: number;
  monthName: string;
} {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return {
    dayName: dateObj.toLocaleDateString('en-US', { weekday: 'long' }),
    dayNum: dateObj.getDate(),
    monthName: dateObj.toLocaleDateString('en-US', { month: 'short' }),
  };
}
